export default __webpack_public_path__ + "static/media/icon-date.1bd87109.svg";